module.exports = "/_next/static/images/howToCZ-18e096193a72f088bc400ee15badaaa2.png";